import { Navigate, Outlet } from 'react-router-dom'

import UnauthorizedView from './routes/errors/UnauthorizedView'
import InvalidLinkView from './routes/errors/InvalidLinkView'
import MainLayout from './components/layout/MainLayout'
import AskView from 'routes/AskView'
import RedirectView from 'routes/RedirectView'
import BlockView from 'routes/BlockBiew'
const routes = [
  {
    path: '/',
    element: <MainLayout><Outlet /></MainLayout>,
    children: [
      { path: '/', element: <InvalidLinkView /> },
      { path: '/readonly/*', element: <RedirectView /> },
      { path: '/:token/readonly/*', element: <RedirectView /> },
      { path: 'block', element: <BlockView /> },
      { path: '401', element: <UnauthorizedView /> },
      { path: '404', element: <InvalidLinkView /> },
      { path: '*', element: <InvalidLinkView /> }
    ]
  },

]

export default routes
